import styled, { css } from 'styled-components'

export const AverageVoivodeshipIncomeValue = styled.h3(({
  theme: {
    palette, typography,
  },
}) => css`
  margin: 0;
  color: ${palette.black};
  font-size: ${typography.main.pt_16_bold.fontSize};
  font-weight: ${typography.main.pt_16_bold.fontWeight};
  line-height: ${typography.main.pt_16_bold.lineHeight};
`)

export const AverageIncomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const AverageIncomeText = styled.p(({
  theme: {
    palette, typography,
  },
}) => css`
  margin: 0;
  color: ${palette.black};
  font-size: ${typography.tiny.pt_10_medium.fontSize};
  font-weight: ${typography.tiny.pt_10_medium.fontWeight};
  line-height: ${typography.tiny.pt_10_medium.lineHeight};
  text-align: center;
`)
